import EditUserNameModal from "./EditUsernamModal";
import ApplyPromoCode from "./ApplyPromoCode";
import EditMobileModal from "./EditMobileModal";
import BonusCaseModal from "./BonusCaseModal";
import RefferCoachMark from "./RefferCoachMark";
import EditEmailModal from "./EditEmailModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import ReferralSystem from "./ReferralSystem";
import UpdateConfirmation from "./ProfileUpdateConfirmation";
import CollectionInfoModal from "./CollectionInfo";
import ContestDetailModal from "./ContestDetail";
import DownloadAppBuyCoinModal from "./DownloadAppBuyCoin";

export {
  EditUserNameModal,
  ApplyPromoCode,
  EditMobileModal,
  EditEmailModal,
  RefferCoachMark,
  BonusCaseModal,
  DeleteConfirmationModal,
  ReferralSystem,
  UpdateConfirmation,
  CollectionInfoModal,
  ContestDetailModal,
  DownloadAppBuyCoinModal
};
